import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Home.css";
import mom from "../../assets/bannermom.png";

const Home = () => {
  return (
    <div className="home-banner">
      <div className="banner">
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center">
            <motion.img
              src={mom}
              className="img-fluid mom-image"
              alt="Mom-Banner"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
              style={{ cursor: "pointer" }}
            />
          </Col>
          <Col xs={12} md={6} className="home-head">
            <motion.img
              src={require("../../assets/Welcom.png")}
              alt="Welcome"
              className="img-fluid welcome-image"
              initial={{ y: "-20px", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1.2 }}
            />
            <motion.img
              src={require("../../assets/welcome1.png")}
              alt="Welcome_Text"
              className="img-fluid"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.5 }}
            />
            <motion.a
              href="/get"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.8 }}
            >
              <button>Track Your Pregnancy</button>
            </motion.a>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Home;
